var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-performance"},[_c('HScroll',[_c('GoalsPanel',{attrs:{"user":_vm.user}}),_c('LeaderBoardPanel'),_c('SellRecordPanel')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }